<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Focus Action</h4>
                    </div>
                    <div class="card-body">
                        <form class="forms-sample" ref="anyName" @submit.stop.prevent="onSubmit" autocomplete="off">
                            <div class="row" style="margin: 0 !important;">
                                <div class="col-xl-5 col-lg-6 col-md-6 left-focus-content">
                                    <div class="form-group m-b-10">
                                        <div class="row" style="margin: 0 !important;">
                                            <label for="FocusName" class="col-xl-3 col-lg-4 col-md-4 control-label">Focus Name:</label>
                                            <div class="col-xl-7 col-lg-8 col-md-8">
                                                <div class="input-group flex-input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon1"><i
                                                                class="fa fa-user"></i></span>
                                                    </div>
                                                    <input type="text" class="form-control" v-model="form.FocusName"
                                                        aria-describedby="basic-addon1" id="FocusName">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-b-10">
                                        <div class="row" style="margin: 0 !important;">
                                            <label for="Definition1" class="col-xl-3 col-lg-4 col-md-4 control-label">Definition 1:</label>
                                            <div class="col-xl-7 col-lg-8 col-md-8">
                                                <div class="input-group flex-input-group">
                                                    <textarea class="form-control" v-model="form.Definition1"
                                                        id="Definition1" rows="3"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-b-10">
                                        <div class="row" style="margin: 0 !important;">
                                            <label for="Definition2" class="col-xl-3 col-lg-4 col-md-4 control-label">Definition 2:</label>
                                            <div class="col-xl-7 col-lg-8 col-md-8">
                                                <div class="input-group flex-input-group">
                                                    <textarea class="form-control" v-model="form.Definition2"
                                                        id="Definition2" rows="3"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-b-10">
                                        <div class="row" style="margin: 0 !important;">
                                            <label for="ActionStep1" class="col-xl-3 col-lg-4 col-md-4 control-label">ActionStep 1:</label>
                                            <div class="col-xl-7 col-lg-8 col-md-8">
                                                <div class="input-group flex-input-group">
                                                    <textarea class="form-control" v-model="form.ActionStep1"
                                                        id="ActionStep1" rows="3"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-b-10">
                                        <div class="row" style="margin: 0 !important;">
                                            <label for="ActionStep2" class="col-xl-3 col-lg-4 col-md-4 control-label">ActionStep 2:</label>
                                            <div class="col-xl-7 col-lg-8 col-md-8">
                                                <div class="input-group flex-input-group">
                                                    <textarea class="form-control" v-model="form.ActionStep2"
                                                        id="ActionStep2" rows="3"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-b-10">
                                        <div class="row" style="margin: 0 !important;">
                                            <label for="Benefits" class="col-xl-3 col-lg-4 col-md-4 control-label">Benefits:</label>
                                            <div class="col-xl-7 col-lg-8 col-md-8">
                                                <div class="input-group flex-input-group">
                                                    <textarea class="form-control" v-model="form.Benefits"
                                                        id="Benefits" rows="3"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-b-10">
                                        <div class="row" style="margin: 0 !important;">
                                            <label for="Target" class="col-xl-3 col-lg-4 col-md-4 control-label">Target:</label>
                                            <div class="col-xl-7 col-lg-8 col-md-8">
                                                <div class="input-group flex-input-group">
                                                    <input class="form-control form-control-sm"
                                                        v-model="form.Target" id="Target" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-5 col-lg-6 col-md-6 right-focus-content">
                                    <div class="form-group m-b-10">
                                        <div class="row" style="margin: 0 !important;">
                                            <label for="ActionStep3" class="col-xl-3 col-lg-4 col-md-4 control-label">ActionStep 3:</label>
                                            <div class="col-xl-7 col-lg-8 col-md-8">
                                                <div class="input-group flex-input-group">
                                                    <textarea class="form-control" v-model="form.ActionStep3"
                                                        id="ActionStep3" rows="3"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-b-10">
                                        <div class="row" style="margin: 0 !important;">
                                            <label for="ActionStep4" class="col-xl-3 col-lg-4 col-md-4 control-label">ActionStep 4:</label>
                                            <div class="col-xl-7 col-lg-8 col-md-8">
                                                <div class="input-group flex-input-group">
                                                    <textarea class="form-control" v-model="form.ActionStep4"
                                                        id="ActionStep4" rows="3"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-b-10">
                                        <div class="row" style="margin: 0 !important;">
                                            <label for="ActionStep5" class="col-xl-3 col-lg-4 col-md-4 control-label">ActionStep 5:</label>
                                            <div class="col-xl-7 col-lg-8 col-md-8">
                                                <div class="input-group flex-input-group">
                                                    <textarea class="form-control" v-model="form.ActionStep5"
                                                        id="ActionStep5" rows="3"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group m-b-10">
                                        <div class="row" style="margin: 0 !important;">
                                            <label for="ActionStep6" class="col-xl-3 col-lg-4 col-md-4 control-label">ActionStep 6:</label>
                                            <div class="col-xl-7 col-lg-8 col-md-8">
                                                <div class="input-group flex-input-group">
                                                    <textarea class="form-control" v-model="form.ActionStep6"
                                                        id="ActionStep6" rows="3"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" style="margin: 0 !important;">
                                <div class="col-md-6"></div>
                                <div class="col-md-6 mt-3">
                                    <b-button type="submit" variant="success" class="btn float-right btn-success">
                                        <span>Submit</span>
                                    </b-button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required, minLength, email, requiredIf, sameAs, integer } from "vuelidate/lib/validators";
import router from '../../router';

export default {
    name: 'Users',
    mixins: [validationMixin],
    data() {
        return {
            form: {
                FocusName: "",
                Definition1: "",
                Definition2: "",
                ActionStep1: "",
                ActionStep2: "",
                ActionStep3: "",
                ActionStep4: "",
                ActionStep5: "",
                ActionStep6: "",
                Benefits: "",
                Target: "",
            },
            isDisabled: false,
        };
    },
    validations: {
        // form: {
        //     Videolink: {
        //         required,
        //     },
        //     VideoOrder: {
        //         required,
        //     },
        //     Active: {
        //         required,
        //     },
        // }
    },
    methods: {
        onSubmit() {
            // this.$v.form.$touch();
            // if (this.$v.form.$anyError) {
            //     return;
            // }
            this.isDisabled = true;
            API.updateFoucs(this.form,
                data => {
                    this.$showNotification({message:"Updated Successfully"}, 'success')
                    this.isDisabled = false;
                },
                err => {
                    this.isDisabled = false;
                    this.errorMsg(err);
                }
            )
        },
        fillData() {
            if (this.$route.params.focus) {
                this.form = this.$route.params.focus;
            } else {
                router.push({ name: "focus_action" });
            }
        },
        errorMsg(err) {
            console.log(err);
            this.$showNotification({ message: "Failed system error" }, 'error')
        }
    }, mounted() {
        this.fillData();
    }, computed: {},
}
</script>

<style>
.flex-input-group {
    flex-wrap: nowrap;
}
.flex-input-group textarea {
    width: 235px;
    height: 99px !important;
}
.right-focus-content {
    margin-top: 44px;
}
@media (max-width: 767px) {
    .right-focus-content {
        margin-top: 0px;
    }
}
@media (max-width: 450px) {
    .right-focus-content {
        padding: 0 !important;
    }
    .left-focus-content {
        padding: 0 !important;
    }
    .left-focus-content .col-md-4, .right-focus-content .col-md-4,
    .left-focus-content .col-md-8, .right-focus-content .col-md-8 {
        padding: 0 !important;
    }
}
</style>
